import axios from 'axios';
import { createAuthInterceptor } from './interceptors/authInterceptor';
import { isOidcAuth } from '../config/featureFlags';
import { userManager } from '../components/OidcAuthProvider';

// Per-request opt-outs of the global error handling in authInterceptor. Declared
// on the axios config so callers can pass them without a local cast.
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorToast?: boolean;
    skipAccessDeniedRedirect?: boolean;
  }
}

// @ts-ignore - Runtime env from config.js
const runtimeUrl = window.ENV?.REACT_APP_API_BASE_DEV_URL;
const isTemplate =
  runtimeUrl && runtimeUrl.startsWith('${') && runtimeUrl.endsWith('}');
const baseURL =
  (isTemplate ? process.env.REACT_APP_API_BASE_DEV_URL : runtimeUrl) ||
  process.env.REACT_APP_API_BASE_DEV_URL;

const API = axios.create({
  baseURL,
  withCredentials: true
});

if (isOidcAuth()) {
  API.interceptors.request.use(async (config) => {
    const user = await userManager.getUser();
    if (user?.access_token && !user.expired) {
      config.headers = config.headers ?? {};
      config.headers['Authorization'] = 'Bearer ' + user.access_token;
    }
    return config;
  });
}

const authInterceptor = createAuthInterceptor(API);
API.interceptors.response.use(
  authInterceptor.response,
  authInterceptor.responseError
);

export default API;
